var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitchCardViewHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_90_54564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.812 3.84545C17.4221 3.64909 17.0156 3.48545 16.5925 3.34636V13.1891C15.6467 12.8536 14.6761 12.6818 13.6888 12.6818C12.1125 12.6818 10.5528 13.1236 9.12587 13.9745V4.07455C7.78188 3.31364 6.23048 2.86364 4.56294 2.86364C3.07791 2.86364 1.67584 3.22364 0.439701 3.84545C0.165925 3.97636 0 4.26273 0 4.56545V14.4491C0 14.9236 0.389924 15.2591 0.829625 15.2591C0.962365 15.2591 1.0951 15.2264 1.22784 15.1609C2.23169 14.6455 3.35998 14.3182 4.56294 14.3182C6.28026 14.3182 7.86484 14.9891 9.12587 15.9545C10.3869 14.9891 11.9715 14.3182 13.6888 14.3182C14.8918 14.3182 16.0201 14.6455 17.0239 15.1691C17.1566 15.2345 17.2894 15.2673 17.4221 15.2673C17.8535 15.2673 18.2517 14.9318 18.2517 14.4573V4.56545C18.2517 4.26273 18.0858 3.97636 17.812 3.84545ZM7.46662 13.1891C6.52085 12.8536 5.55019 12.6818 4.56294 12.6818C3.57568 12.6818 2.60502 12.8536 1.65925 13.1891V5.08091C2.58013 4.69636 3.55079 4.5 4.56294 4.5C5.55849 4.5 6.54574 4.70455 7.46662 5.08909V13.1891ZM14.9332 0L10.7851 4.09091V11.8636L14.9332 8.18182V0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_90_54564"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchCardViewHover);
export default __webpack_public_path__ + "static/media/switch-card-view-hover.48a0aaa5674488610dbe31af7994b15a.svg";
export { ForwardRef as ReactComponent };